import React, { useState } from "react";

const StepGuardian = ({ formData, setFormData }) => {
  const [touched, setTouched] = useState({});

  // ✅ Removed double localStorage read/write — MultiStepForm owns that

  const guardian = formData?.guardian || {};

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, guardian: { ...prev.guardian, [name]: value } }));
  };

  const handleBlur = (e) => {
    setTouched((prev) => ({ ...prev, [e.target.name]: true }));
  };

  const errors = {
    guardianName: !guardian.guardianName,
    ward:         !guardian.ward,
    village:      !guardian.village,
  };

  const inputClass = (name) =>
    `w-full border-2 rounded-xl px-3 py-2.5 text-sm focus:outline-none transition-colors duration-150 ${
      touched[name] && errors[name]
        ? "border-red-400 focus:border-red-500 bg-red-50"
        : "border-gray-200 focus:border-primary hover:border-gray-300 bg-white"
    }`;

  const labelClass = "block text-sm font-medium text-gray-700 mb-1.5";
  const errorText  = "text-xs text-red-500 mt-1 flex items-center gap-1";

  return (
    <section className="max-w-4xl mx-auto bg-white border border-gray-200 rounded-xl p-4 sm:p-6 md:p-8 space-y-6">
      <div>
        <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-900 mb-1">
          Section C: Guardian Information
        </h2>
        <p className="text-gray-500 text-sm">Provide information about your parent or guardian.</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-5">

        <div>
          <label className={labelClass}>Guardian Name <span className="text-red-500">*</span></label>
          <input type="text" name="guardianName" value={guardian.guardianName || ""} onChange={handleChange} onBlur={handleBlur} placeholder="Full name of parent or guardian" className={inputClass("guardianName")} />
          {touched.guardianName && errors.guardianName && <p className={errorText}><span>⚠</span> This field is required</p>}
        </div>

        <div>
          <label className={labelClass}>
            Guardian ID Number
            <span className="ml-1 text-xs text-gray-400 font-normal">(optional)</span>
          </label>
          <input type="text" name="guardianId" value={guardian.guardianId || ""} onChange={handleChange} placeholder="National ID number" className={inputClass("guardianId")} />
        </div>

        {/* ✅ Added missing guardianPhone field — backend reads guardian.guardianPhone */}
        <div>
          <label className={labelClass}>
            Guardian Phone
            <span className="ml-1 text-xs text-gray-400 font-normal">(optional)</span>
          </label>
          <input type="tel" name="guardianPhone" value={guardian.guardianPhone || ""} onChange={handleChange} placeholder="e.g. 0712 345 678" className={inputClass("guardianPhone")} />
        </div>

        <div>
          <label className={labelClass}>Ward <span className="text-red-500">*</span></label>
          <input type="text" name="ward" value={guardian.ward || ""} onChange={handleChange} onBlur={handleBlur} placeholder="e.g. Igembe Central" className={inputClass("ward")} />
          {touched.ward && errors.ward && <p className={errorText}><span>⚠</span> This field is required</p>}
        </div>

        <div>
          <label className={labelClass}>Village <span className="text-red-500">*</span></label>
          <input type="text" name="village" value={guardian.village || ""} onChange={handleChange} onBlur={handleBlur} placeholder="Guardian's village" className={inputClass("village")} />
          {touched.village && errors.village && <p className={errorText}><span>⚠</span> This field is required</p>}
        </div>

      </div>
    </section>
  );
};

export default StepGuardian;